import styled from 'styled-components/macro';

export const AvatarBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Avatar = styled.img`
  border-radius: 25px;
  width: 25px;
`;
